import { render, staticRenderFns } from "./smsPayment.vue?vue&type=template&id=89801a2c&"
import script from "./smsPayment.vue?vue&type=script&lang=js&"
export * from "./smsPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports